<template>
   <VMenu
      :close-on-content-click="true"
      @input="isSubMenuOpen = false"
      rounded="4"
      offset-y
      class="hidden-md-and-up"
    >
      <template #activator="{ on, attrs }">
        <VBtn
          v-blur
          light
          color="white"
          class="ml-3 shadow-none"
          fab
          small
          v-bind="attrs"
          v-on="on"
        >
          <VIcon>
            mdi-menu
          </VIcon>
        </VBtn>
      </template>

      <VList
        nav
        dense
        class="py-2 px-1"
      >  
        <template v-for="(item, index) in toolbarItems">
          <VListGroup
            v-if="item.subMenu"
            class="header__link body-1"
            @click.stop
            :key="index"
            v-model="isSubMenuOpen"
            no-action
            exact
          >

            <template v-slot:activator>
              <VListItem class="header__submenu-link"> 
                <VListItemContent>
                  <VListItemTitle>
                    <span
                      class="text-capitalize body-1"
                    >{{ item.strapiText || $t(item.text) }}</span>
                  </VListItemTitle>
                </VListItemContent>
              </VListItem>
            </template>

            <VListItem
              v-for="subItem in item.subMenu"
              :key="subItem.title"
              :to="{ name: subItem.value }"
              class="header__link body-1 pl-8"
              exactActiveClass="active"
            >
              <span
                class="text-capitalize body-1"
              >{{ subItem.strapiText || $t(subItem.text) }}</span>
            </VListItem>
          </VListGroup>

          <VListItem
            v-else
            :key="index"
            :to="{ name: item.value }"
            exact
            class="header__link body-1"
            exactActiveClass="active"
          >
            <slot name="customLink">
              <VListItemTitle class="body-1">
                {{ item.strapiText || $t(item.text) }}
              </VListItemTitle>
            </slot>
          </VListItem>
        </template>
      </VList>
    </VMenu>
</template>
<script lang="ts">
export default {
  name: 'TheMobileMenu',
};
</script>

<script setup lang="ts">
import { ref } from 'vue';

defineProps({
  toolbarItems: {
    type: Array,
    default: () => [],
    required: false,
  },
});

const isSubMenuOpen = ref(false);
</script>

<style scoped lang="scss">
@import "@slg/web-customer-shared/src/style/headerLinks.scss";
</style>
